import { render, staticRenderFns } from "./DanSchmidt.vue?vue&type=template&id=515ff534&scoped=true&"
import script from "./DanSchmidt.vue?vue&type=script&lang=js&"
export * from "./DanSchmidt.vue?vue&type=script&lang=js&"
import style0 from "./DanSchmidt.vue?vue&type=style&index=0&id=515ff534&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "515ff534",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VSpacer})
